import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="container">
        <p className="footer-brand">Retro Phone Revival Project</p>
        <p className="footer-credit">
          <span>Made with love by</span>
          <a
            href="https://www.xiaohongshu.com/user/profile/6598154500000000220039ce?xsec_token=ABo5h8MqbdDDgusZdUiZ8xVuE7CIaxHt8rfLEO3tM0N9o%3D&xsec_source=pc_search"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong> replaylab</strong>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer; 